import { DOCUMENT } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { Component, inject, Inject, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, RouterState, Event } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DataLayerService } from './services/dataLeyer/data-leyer.service';
import { DevtoolsDetectorService } from './services/devtools.service';
import { AuthService } from './services/auth/auth.service';
import { UtmHandlerService } from './services/utm-handler.service';
import { LoaderService } from './services/general/loader.service';
import { isDevMode } from '@angular/core';
import { environment } from '../environments/environment';

@Component({
  selector: 'arrendamientos-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: []
})

export class AppComponent {
  utmHandlerService = inject(UtmHandlerService);
  loaderService = inject(LoaderService);
  private renderer = inject(Renderer2);
  private authService = inject(AuthService);
  index: number = 0;
  sessionId: string = '';
  isLoading: boolean = false;

  constructor(
    private router: Router,
    private titleService: Title,
    private _dataLayerService: DataLayerService,
    private devtoolsDetectorService: DevtoolsDetectorService,
    @Inject(DOCUMENT) private document: Document
  ) {
    const sessionId = Date.now().toString();
    this.sessionId = sessionId;
    this.authService.setSessionId(sessionId);
    localStorage.setItem('session_id', sessionId);

    router.events
      .pipe(filter((routerEvent: Event) => routerEvent instanceof NavigationEnd))
      .subscribe(() => window.scrollTo(0, 0));
  }

  ngOnInit(): void {
    this.injectChatScript();
    // Suscribirse al estado de carga global
    this.loaderService.loading$.subscribe(({ loading, loaded }: { loading: boolean; loaded: boolean }) => {
      this.isLoading = loading;
    });

    // Inicializar el detector de herramientas de desarrollo
    this.devtoolsDetectorService.initialize();
    const httpOptions = { headers: new HttpHeaders() };
    httpOptions.headers.append('Content-Type', 'application/x-gzip');

    // Establecer título fijo para toda la aplicación
    this.titleService.setTitle('Cotiza tu Seguro de arrendamiento Digital - SURA');

    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {

        // if (this.index == 0) {
        //   this._dataLayerService.logPageLoad("ecommerce_step_0", "Arrendamiento", "Inicio Arrendamiento", this.sessionId);
        //   this.index = this.index + 1;
        // }
      }
    });


  }

  injectChatScript() {
    const scriptId = 'chat-app-script'; // ID único para identificarlo
    
    // 1. Verificar si ya existe el script con ese ID
    const existingScript = this.document.getElementById(scriptId);
    
    if (!existingScript) {
      const script = this.renderer.createElement('script');
      script.id = scriptId; // Le asignamos el ID
      script.type = 'module';
      script.src = environment.URL_CLICK_TO_CALL; 
      script.crossOrigin = 'anonymous';
      script.async = true;

      this.renderer.appendChild(this.document.head, script);
    }
  }

}

